import React, { useState } from 'react'
import Pagination from 'components/molecules/Pagination/Pagination'
import { deletePattern } from 'services/templateService'
import { LoaderTransparent } from 'components/molecules/LoaderTransparent/LoaderTransparent'
import PatternCardItem from 'components/molecules/PatternCardItem/PatternCardItem'
import { Box } from '../../atoms/AppBox'
import { useNavigate } from 'react-router-dom'
import StatusToast from 'components/molecules/StatusToast/StatusToast'
import { useTemplates } from 'templates/presentation/hooks/useTemplates'
import { TemplateFilterBar } from 'templates/presentation/components/organisms/TemplateFilterBar'

export default function PatternList() {
    const navigate = useNavigate()
    const [activeTab, setActiveTab] = useState<string>('all')
    const [messageError, setMessageError] = useState('')
    const [toastType, setToastType] = useState<'error' | 'success' | 'loading'>('error')

    const { templates, loading, pagination, fetchTemplates } = useTemplates()

    const handleTabChange = (tabId: string) => {
        setActiveTab(tabId)
        if (tabId === 'all') {
            fetchTemplates({ operationModeId: undefined, page: 1 })
        } else {
            fetchTemplates({ operationModeId: parseInt(tabId, 10), page: 1 })
        }
    }

    const changePage = (page: number) => {
        fetchTemplates({ page })
    }

    const deleteTemplate = async (id: number) => {
        try {
            await deletePattern(id)
            setToastType('success')
            setMessageError('Plantilla eliminada satisfactoriamente')
            fetchTemplates()
        } catch (error) {
            setToastType('error')
            setMessageError(
                typeof error === 'object' && error !== null && 'message' in error
                    ? String((error as { message: unknown }).message)
                    : 'Error al eliminar la plantilla'
            )
        }
        setTimeout(() => setMessageError(''), 3000)
    }

    return (
        <div>
            {messageError && <StatusToast title={messageError} type={toastType} />}
            <Box>
                {loading && <LoaderTransparent />}

                <TemplateFilterBar
                    activeTab={activeTab}
                    totalAllTemplates={pagination.totalAllTemplates}
                    totalByClassificationType={pagination.totalByClassificationType}
                    onTabChange={handleTabChange}
                    fetchTemplates={fetchTemplates}
                />

                <div className="flex flex-col justify-between h-full">
                    <div className="overflow-y-auto" style={{ height: '500px' }}>
                        {templates.length > 0 ? (
                            templates.map((template, index) => (
                                <PatternCardItem
                                    key={index}
                                    id={template.id!}
                                    title={template.name}
                                    countRules={template.countGroups || 0}
                                    countChutes={template.countChutes || 0}
                                    operationMode={template.operationMode}
                                    nameWarehouse={template.warehouseName || ''}
                                    onSubmit={() => navigate(`/templates/show/${template.id}`)}
                                    deletePattern={() => template.id && deleteTemplate(template.id)}
                                    editPattern={() => navigate(`/templates/edit/${template.id}`)}
                                />
                            ))
                        ) : (
                            <div className="flex justify-center p-4 text-sm text-[#475569]">
                                No hay plantillas para mostrar
                            </div>
                        )}
                    </div>
                    <div className="flex justify-center mt-10">
                        <Pagination
                            totalPages={Math.ceil(pagination.totalItems / pagination.itemsPerPage)}
                            currentPage={pagination.page}
                            onPageChange={changePage}
                        />
                    </div>
                </div>
            </Box>
        </div>
    )
}
